import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';

export const authCodeFlowConfig: AuthConfig = {
	redirectUri: window.location.href,
	silentRefreshRedirectUri: window.location.origin + '/assets/silent-refresh.html',
	clientId: environment.auth.clientId,
	responseType: 'code',
	requestAccessToken: false,
	scope: environment.auth.clientId + ' openid offline_access profile',
	issuer: environment.auth.issuer,
	strictDiscoveryDocumentValidation: false,
	showDebugInformation: !environment.production,
	preserveRequestedRoute: true,
	clearHashAfterLogin: true,
	postLogoutRedirectUri: environment.auth.redirectUri,
};
